import React from 'react';
import { IProgramListItemProps } from '../../../interfaces/interfaces';
import Accordion from '../Accordion/Accordion';
import ProgramListSelect from './ProgramListSelect';

function ProgramListItem(props: IProgramListItemProps): JSX.Element {
  const { item, onChange } = props;
  const { title, tiles, id, displayNumber } = item;

  if (tiles && tiles.length) {
    return (
      <li className="item-list-item program-list-item has-subitems">
        <Accordion title={`${title} (${displayNumber})`} contentCount={0} className="program-accordion">
          <ProgramListSelect program={item} onChange={onChange} />
        </Accordion>
      </li>
    );
  }

  return <></>;
}
export default ProgramListItem;
